import React, { useEffect, useState } from 'react';
import IPage from '../interfaces/page';
import { useNavigate, useParams } from "react-router-dom";
import { Container } from 'react-bootstrap';
import axios from 'axios';
import config from '../config/config';
import simirity_logo from "../assets/images/logo2_with_tagline_horizontal.svg";
import i18n from "../i18n";
import { useTranslation } from 'react-i18next';
import { Modal } from "react-bootstrap";
import instance from '../api/api';

interface IProps {
    sharer: string;
    review: string;
    avatar: any;
}

const Welcome: React.FunctionComponent<IPage> = (props) => {

    const navigate = useNavigate();
    const { t } = useTranslation();

    const [ data, setData ] = useState<IProps[]>([]);
    const [ inviter, setInviter ] = useState<string>("");

    const [showVideoModal, setShowVideoModal] = useState<boolean>(false);

    const { id, lang } = useParams();

    useEffect(() => {
        if(lang) {
            i18n.changeLanguage(lang);
        }
        if(id) {
            validateInvitation(id);
        }
        fetchwelcomeData();
    }, [])

    async function fetchwelcomeData() {        
        axios.get(`${config.contentServerURL}/api/user-reviews?sort[0]=sortOrder:asc`).then(resp => { // Strapi v4 query format
            setData(resp.data.data);
        }, error => {
            console.log("Failed to get user reviews", error)
        });
    }

    // clone from registration page
    async function validateInvitation(id:string) {
        try {
            const response = await instance.get("/invitation/public/" + id);

            console.log(inviter)

            if(response.data.length) {
                setInviter(response.data);
            }
        }
        catch(err) {
            // nop: let user pass through to registration page
        }
    }        


    return(
        <>    
            <Container className="welcome-container">
                <img src={simirity_logo} alt="simirity" className="logo" />
                <p className="title">{t("Welcome")}</p>
                <p className='motto'>{t("Share life stories today, while storing")}<br />{t("cherished memories for tomorrow.")}</p>
                <div className='open-by-link'>
                    {/*<ExampleStory openByLink={true} />*/}                    
                    <p className="link-text" onClick={() => window.open('https://www.simirity.com/', '_blank', 'noopener,noreferrer')}>{t("LEARN ABOUT SIMIRITY")}</p>
                </div>                
                <div className="usertips-container">
                    <div className="usertips-content">
                        <div className="modal-iframe-custom">
                            <iframe src={`https://player.vimeo.com/video/849109482`} width="460" height="238" allow="autoplay; fullscreen; picture-in-picture"></iframe>
                        </div>
                    </div>
                </div>
                <p className='join'>{inviter ? `${t("Join")} ${inviter} ${t("today")}` : t("Join your family today")}</p>
                <button className="default-button" onClick={() => navigate(`/register${lang ? "/"+lang : ''}`, { state: { id: id ? id : ''}})}>{t("Join For Free")}</button>
            </Container>

            {showVideoModal ?
                <Modal className="video-welcome-modal" show={showVideoModal} onHide={() => setShowVideoModal(false)}>
                    <Modal.Header>
                        <Modal.Title>{t("Why Stories Matter")}</Modal.Title>
                        <button type="button" className="btn-close" aria-label="Close" onClick={() => setShowVideoModal(false)}></button>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="modal-iframe-custom">
                            <iframe width="100%" src="https://www.youtube.com/embed/URvHVnDTZ50" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe>
                        </div>
                    </Modal.Body>
                </Modal> : null}
        </>
    )
};

export default Welcome;